import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file index.tsx
 * @author markJia(markjia@tencent.com)
 */
import React from 'react';
import { withViewComponent } from '../../hoc/withViewComponent';
import { Close } from '@tencent/adp-icons-react';
import { Button } from '../../components';
export var ViewContent = withViewComponent(function ($p, $s, $c, $a) {
  var closable = $p.closable,
      closeIcon = $p.closeIcon,
      onOk = $p.onOk,
      _$p$okText = $p.okText,
      okText = _$p$okText === void 0 ? '确定' : _$p$okText,
      okProps = $p.okProps,
      cancelProps = $p.cancelProps,
      onCancel = $p.onCancel,
      _$p$cancelText = $p.cancelText,
      cancelText = _$p$cancelText === void 0 ? '取消' : _$p$cancelText,
      header = $p.header,
      width = $p.width,
      style = $p.style,
      headerClassName = $p.headerClassName,
      headerStyle = $p.headerStyle,
      _$p$title = $p.title,
      title = _$p$title === void 0 ? 'Title' : _$p$title,
      bodyClassName = $p.bodyClassName,
      bodyStyle = $p.bodyStyle,
      footer = $p.footer,
      footerClassName = $p.footerClassName,
      footerStyle = $p.footerStyle,
      children = $p.children;

  var getCloseIcon = function getCloseIcon() {
    if (!closable) {
      return null;
    }

    return React.createElement("div", {
      className: $c('close-icon'),
      onClick: onCancel
    }, closeIcon || React.createElement(Close, {
      size: 12
    }));
  };

  var getHeader = function getHeader() {
    if (header || header === null || header === false) {
      return header;
    }

    return React.createElement("div", {
      className: $c('header', {
        closable: closable
      }, false, headerClassName),
      style: headerStyle
    }, React.createElement("div", {
      className: $c('title')
    }, title), getCloseIcon());
  };

  var getFooter = function getFooter() {
    if (footer || footer === null || footer === false) {
      return footer;
    }

    return React.createElement("div", {
      className: $c('footer', undefined, false, footerClassName),
      style: footerStyle
    }, React.createElement(Button, _objectSpread(_objectSpread({}, okProps), {}, {
      className: $c('cancel'),
      onClick: onCancel
    }), cancelText), React.createElement(Button, _objectSpread(_objectSpread({}, cancelProps), {}, {
      className: $c('ok'),
      type: "primary",
      onClick: onOk
    }), okText));
  };

  var modelWidth = width || (style === null || style === void 0 ? void 0 : style.width);
  return React.createElement("div", _objectSpread(_objectSpread({
    className: $c(true, {
      closable: closable
    }, true)
  }, $a), {}, {
    style: _objectSpread(_objectSpread({}, style), {}, {
      minWidth: width !== null && width !== void 0 ? width : 300,
      width: modelWidth
    })
  }), getHeader(), React.createElement("div", {
    className: $c('body', undefined, false, bodyClassName),
    style: bodyStyle
  }, children), getFooter());
}, 'content', ['className', 'style', 'closable', 'closeIcon', 'onOk', 'okText', 'okProps', 'width', 'cancelProps', 'onCancel', 'cancelText', 'header', 'headerClassName', 'headerStyle', 'bodyClassName', 'bodyStyle', 'title', 'footer', 'footerClassName', 'footerStyle', 'children']);